import React from 'react';
import { AppBarItem } from './AppBarItem';
import { appBarCss } from '../utils';
import './AppBar.scss';
export const AppBar = ({ children, menuItems = [], }) => {
    const { appBar, appBarTitle } = appBarCss();
    return (React.createElement("div", { className: appBar },
        React.createElement("div", { className: appBarTitle }, children),
        menuItems.map((item, index) => (React.createElement(AppBarItem, { key: item.key || index, data: item })))));
};
//# sourceMappingURL=AppBar.js.map